import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducers from 'app/reducers';
import { updateSearchResults } from 'app/actions/galleryActions';

const middleware = [thunk];

// link to redux devtools extension repo: https://github.com/zalmoxisus/redux-devtools-extension
// In order to use this you will need to download the redux devtools chrome extension: https://chrome.google.com/webstore/detail/redux-devtools/lmhkpmbekcpmknklioeibfkpmmfibljd?hl=en-US
const composeEnhancers =
  (typeof window !== 'undefined' &&
    // Core redux setup.
    // eslint-disable-next-line no-underscore-dangle
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;
const configureStore = (preloadedState = {}) =>
  createStore(
    rootReducers,
    preloadedState,
    composeEnhancers(applyMiddleware(...middleware))
  );

export const configureSearchStore = (searchPayload) => {
  const store = configureStore();
  const { dispatch } = store;
  const searchResults = searchPayload.search;
  dispatch(updateSearchResults(searchResults));
  return store;
};

// Minimal store for error pages (404, 410) that don't need preloaded state
export const configureErrorPageStore = () => configureStore();

export default configureStore;
